import { ICellRendererParams } from "ag-grid-community";
import {  Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { IAlarmRecipientDto } from "../../services/admin-report-data-service/Models";


export function RecipientListRenderer({
    value,
    data,
}: ICellRendererParams) {

    //console.log(JSON.stringify(value));
    //const recipients = data?.v2recipientList as IAlarmRecipientDto[];
    const recipients = value as IAlarmRecipientDto[];

    return (recipients && recipients.length > 0
        ? 
        <Stack direction='column' sx={{overflow: 'hidden'}}>
            {recipients.map((o, ndx) => (
                
                <React.Fragment key={o.recipientID}>
                    <Typography component="span" 
                        variant="body2" 
                        sx={{ 
                            fontSize: ".8rem",
                            fontWeight: o.recipientDisabled ? 'bold' : undefined,
                            textDecoration: o.recipientDisabled ? 'line-through' : undefined,
                        }}>
                        {o.recipientTo}
                    </Typography>
        
                    {o.userFirstName && o.userLastName && (
                        <Typography component="span" 
                            variant="body2" 
                            sx={{ 
                                fontSize: ".8rem" ,
                                fontWeight: o.userDisabled ? 'bold' : undefined,
                                textDecoration: o.userDisabled ? 'line-through' : undefined,

                            }}>
                            {`[${o.userFirstName} ${o.userLastName}]`}
                        </Typography>
                    )}
                    <Typography component="span" variant="body2" sx={{ fontSize: ".8rem" }}>
                            {/* {`(${o.recipientTypeName})${ndx < recipients.length - 1 ? ', ' : ''}`} */}
                            {`(${o.recipientTypeName})`}
                    </Typography>

                    {ndx < recipients.length - 1 && <Divider sx={{ mt: 1, mb: 1 }} />}
                    

                </React.Fragment>
            ))}

        </Stack>
        : <Typography component="span" variant="body2" sx={{ fontSize: ".8rem" }}>
            {data.directRecipient ? "(no recipients)" : "(Notification list is empty)"}
        </Typography>
    )
}

